"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var react_error_boundary_1 = require("react-error-boundary");
var mobx_react_1 = require("mobx-react");
// locals
var util_1 = require("../util");
// ui elements
var ErrorMessage_1 = __importDefault(require("./ErrorMessage"));
var LoadingEllipses_1 = __importDefault(require("./LoadingEllipses"));
var ViewContainer_1 = __importDefault(require("./ViewContainer"));
var ViewPanel = (0, mobx_react_1.observer)(function (_ref) {
  var view = _ref.view,
    session = _ref.session;
  var _ref2 = (0, util_1.getEnv)(session),
    pluginManager = _ref2.pluginManager;
  var viewType = pluginManager.getViewType(view.type);
  if (!viewType) {
    throw new Error("unknown view type ".concat(view.type));
  }
  var ReactComponent = viewType.ReactComponent;
  return react_1.default.createElement(ViewContainer_1.default, {
    view: view,
    onClose: function onClose() {
      return session.removeView(view);
    },
    onMinimize: function onMinimize() {
      return view.setMinimized(!view.minimized);
    }
  }, !view.minimized ? react_1.default.createElement(react_error_boundary_1.ErrorBoundary, {
    FallbackComponent: function FallbackComponent(_ref3) {
      var error = _ref3.error;
      return react_1.default.createElement(ErrorMessage_1.default, {
        error: error
      });
    }
  }, react_1.default.createElement(react_1.Suspense, {
    fallback: react_1.default.createElement(LoadingEllipses_1.default, {
      variant: "h6"
    })
  }, react_1.default.createElement(ReactComponent, {
    model: view,
    session: session
  }))) : false);
});
exports.default = ViewPanel;